/**
 * Promo strip on /home that deep-links into the currently active poll.
 *
 * Sibling of `refer_fiftyfifty_banner.js` / `buy_eraser_banner.js` /
 * `buy_fiftyfifty_banner.js`. Same card shape so the 4-way picker on
 * the admin dashboard renders identically regardless of which option
 * is on.
 *
 * Gradient mixes the brand violet + gold for "vote / decide / weigh
 * in" energy. Links to /polls/{id} where the voter UI lives.
 */

import { escape } from '../components/form.js';

export function pollBannerHtml(poll) {
  if (!poll || !poll.id) return '';
  const href = `/polls/${encodeURIComponent(poll.id)}`;
  return `
    <div
      class="card poll-banner"
      style="padding:8px 10px;margin-bottom:8px;background:linear-gradient(135deg,#5B2C91 0%,#C8901F 100%);border-color:rgba(247,198,103,0.55);"
    >
      <a href="${href}" data-link class="row"
         style="align-items:center;gap:8px;text-decoration:none;color:inherit;min-width:0;">
        <div style="font-size:18px;line-height:1;color:#F7C667;flex-shrink:0;">
          <svg viewBox="0 0 24 24" width="18" height="18"
               aria-hidden="true" style="display:block;" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="6" width="18" height="13" rx="2"/>
            <polyline points="8 12 11 15 16 9"/>
          </svg>
        </div>
        <div class="grow" style="min-width:0;">
          <div style="color:#fff;font-weight:700;font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            Vote — ${escape(poll.question || 'have your say')}
          </div>
          <div style="color:rgba(255,255,255,0.78);font-weight:500;font-size:10.5px;line-height:1.25;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            ${poll.closes_at ? `Closes ${_shortDate(poll.closes_at)} · tap to vote` : 'Tap to cast your vote.'}
          </div>
        </div>
        <span
          class="btn sm"
          style="padding:4px 10px;font-size:12px;line-height:1.2;flex-shrink:0;margin:0;background:rgba(247,198,103,0.22);border:1px solid rgba(247,198,103,0.55);color:#fff;font-weight:700;"
        >
          Vote
        </span>
      </a>
    </div>
  `;
}

function _shortDate(iso) {
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return '';
  }
}
